//src/components/UI/Dropdown.jsx

import React, { useState } from "react";

export default function Dropdown({
  label,
  value,
  options,
  getLabel,
  onChange,
}) {
  const [open, setOpen] = useState(false);

  const selected = options.find(o => o.id === value);

  return (
    <div className="relative w-full">

      {/* TRIGGER */}
      <div
        onClick={() => setOpen(!open)}
        className="
          w-full border border-gray-200 rounded-xl px-3 py-2
          bg-white cursor-pointer
          hover:bg-gray-50 transition
        "
      >
        {selected ? getLabel(selected) : "Выбрать..."}
      </div>

      {/* LIST */}
      {open && (
        <div className="
          absolute z-50 mt-2 w-full
          bg-white border border-gray-100
          rounded-xl shadow-lg
          max-h-60 overflow-auto
        ">
          {options.map(opt => (
            <div
              key={opt.id}
              onClick={() => {
                onChange(opt.id);
                setOpen(false);
              }}
              className="
                px-3 py-2 cursor-pointer
                hover:bg-gray-50 active:bg-gray-100
                transition
              "
            >
              {getLabel(opt)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
